import { api, ENDPOINTS } from '../config';
import { AutomationResponseData, CreateAutomationParams } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getAutomations(): Promise<AutomationResponseData[]> {
  const response = await api.get(ENDPOINTS.AUTOMATIONS);
  
  return response.data;
}

export async function getAutomation(id: string): Promise<AutomationResponseData[]> {
  const response = await api.get(`${ENDPOINTS.AUTOMATIONS}${id}/`);
  
  return response.data;
}

export async function createAutomation(params: CreateAutomationParams): Promise<AutomationResponseData> {
  const response = await api.post(ENDPOINTS.AUTOMATIONS, {
    ...params,
  });
  
  return response.data;
}

export async function editAutomation(id: string, params: CreateAutomationParams): Promise<AutomationResponseData> {
  const response = await api.patch(`${ENDPOINTS.AUTOMATIONS}${id}/`, {
    ...params,
  });
  
  return response.data;
}

export async function duplicateAutomation(id: string): Promise<AutomationResponseData> {
  const response = await api.post(`${ENDPOINTS.AUTOMATIONS}${id}/duplicate/`);
  
  return response.data;
}

export async function deleteAutomation(id: string): Promise<AutomationResponseData> {
  const response = await api.delete(`${ENDPOINTS.AUTOMATIONS}${id}/`);
  
  return response.data;
}